export function tryOnCalibrationFrom(data = {}) {
  return {
    try_on_opacity: data.try_on_opacity == null ? 0.65 : data.try_on_opacity,
    try_on_coverage: data.try_on_coverage == null ? 0.75 : data.try_on_coverage,
    try_on_brightness: data.try_on_brightness == null ? 1 : data.try_on_brightness,
  };
}
export function validTryOnCalibration(form) {
  return [['try_on_opacity', 0, 1], ['try_on_coverage', 0, 1], ['try_on_brightness', 0.5, 1.5]].every(([name, min, max]) =>
    form[name] !== '' && Number.isFinite(Number(form[name])) && Number(form[name]) >= min && Number(form[name]) <= max);
}
export function appendTryOnCalibration(data, form) {
  ['try_on_opacity', 'try_on_coverage', 'try_on_brightness'].forEach(name => data.append(name, String(form[name])));
}
